import React from "react";

import ReactDOM from "react-dom/client";

import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
} from "@mui/material/styles";

import { QueryClientProvider } from "@tanstack/react-query";

import App from "./App";

import AuthProvider from "./context/AuthContext";

import ScanProvider from "./context/ScanContext";

import ThemeProvider from "./context/ThemeContext";

import ToastProvider from "./components/ToastProvider";

import ConfirmProvider from "./components/ConfirmProvider";

import { queryClient } from "./lib/queryClient";

import { BODY_FONT, HEADING_FONT } from "./theme/fonts";

const muiTheme = createTheme({
  typography: {
    fontFamily: BODY_FONT,
    // Headings use Montserrat across the app.
    h1: { fontFamily: HEADING_FONT },
    h2: { fontFamily: HEADING_FONT },
    h3: { fontFamily: HEADING_FONT },
    h4: { fontFamily: HEADING_FONT },
    h5: { fontFamily: HEADING_FONT },
    h6: { fontFamily: HEADING_FONT },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(

  <QueryClientProvider client={queryClient}>

    <MuiThemeProvider theme={muiTheme}>

      <ThemeProvider>

        <ToastProvider>

          <ConfirmProvider>

            <AuthProvider>

              <ScanProvider>

                <App />

              </ScanProvider>

            </AuthProvider>

          </ConfirmProvider>

        </ToastProvider>

      </ThemeProvider>

    </MuiThemeProvider>

  </QueryClientProvider>

);